import React from "react";
import { Fab, Icon } from "@mui/material";
import MDBox from "components/MDBox";
import PropTypes from "prop-types";

const AddFloatingButton = ({ onClick, icon = "add", ariaLabel = "add", sx = {}, disabled }) => {
  return (
    <MDBox sx={{ position: "fixed", bottom: 20, right: 20, ...sx }}>
      <Fab color="primary" aria-label={ariaLabel} onClick={onClick} disabled={disabled}>
        <Icon>{icon}</Icon>
      </Fab>
    </MDBox>
  );
};

AddFloatingButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  icon: PropTypes.string,
  ariaLabel: PropTypes.string,
  sx: PropTypes.object,
  disabled: PropTypes.bool,
};

export default AddFloatingButton;
